import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IUserGroup } from './IUserGroup';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserGroupLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/UserGroup`;

  public get (): Observable<Array<IUserGroup>> {
    this.log.verbose({ type: 'UserGroupLookupService:get', uri: this.uri });
    return this.http.get<Array<IUserGroup>>(this.uri)
      .pipe(tap(res => this.log.verbose({ type: 'UserGroupLookupService:reponse', res })))
      ;
  }

}
